import { render, staticRenderFns } from "./ProjectSalesReport.vue?vue&type=template&id=2d980102&scoped=true"
import script from "./ProjectSalesReport.vue?vue&type=script&lang=js"
export * from "./ProjectSalesReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectSalesReport.vue?vue&type=style&index=0&id=2d980102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d980102",
  null
  
)

export default component.exports